import useAuth from 'hooks/use-auth'
import {
  activeAlfiClientSelector,
  activeInfraClientSelector,
  alfiClientsSelector,
  infraClientsSelector,
  useAlfiClients,
  useAlfiClientsStore,
  useInfraClientsStore,
  useInfraClients
} from 'hooks/use-clients'

/*
 Used for specialized cases were active infra and alfi clients are combined into a single list
 */
export default function useClientResource() {
  const { companyIsAlfiEnabled: isAlfiEnabled } = useAuth()

  const clientStatus = useInfraClientsStore((s) => s.status)
  const infraClients = useInfraClientsStore(infraClientsSelector)
  const activeInfraClients = useInfraClientsStore(activeInfraClientSelector)
  const { refetch } = useInfraClients({ enabled: false })

  const alfiStatus = useAlfiClientsStore((s) => s.status)
  const alfiClients = useAlfiClientsStore(alfiClientsSelector)
  const activeAlfiClients = useAlfiClientsStore(activeAlfiClientSelector)
  const { refetch: refetchAlfiClients } = useAlfiClients({ enabled: false })

  const activeClients = activeInfraClients.concat(activeAlfiClients)
  return {
    infraClients: infraClients,
    infraIsLoading: clientStatus === 'loading',
    infraHasError: clientStatus === 'error',
    fetchInfraClients: refetch,
    alfiClients: alfiClients,
    alfiIsLoading: isAlfiEnabled && alfiStatus === 'loading',
    alfiHasError: alfiStatus === 'error',
    fetchAlfiClients: refetchAlfiClients,
    activeClients: activeClients,
    hasClients: activeClients.length > 0
  }
}
